import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import AwardModel from 'models/Award';

import Wrapper from './styled/Wrapper';
import Number from './styled/Number';
import Icon from './styled/Icon';

export default class AwardCounter extends PureComponent {


  static defaultProps = {
    count: 0,
  };

  render() {
    const { className, count, award } = this.props;

    return (
      <Wrapper className={className}>
        <Number>{count}</Number>
        <Icon src={award.image.url} />
      </Wrapper>
    );
  }
}
